module.exports = __webpack_public_path__ + "img/presentation.ef377b86.png";